const positiveId = value => {
	const normalized = String(value ?? '')
	return /^[1-9]\d*$/.test(normalized) ? Number(normalized) : null
}

// A membership is selected from a PlatformAdmin diagnostic response. It is not
// inferred from the current CRM organization or from a role in browser state.
export function createImpersonationTarget({ user, membership }) {
	const effectiveUserId = positiveId(user?.id)
	const organizationId = positiveId(membership?.organization_id ?? membership?.organizationId)
	const membershipId = positiveId(membership?.id)
	const membershipUserId = positiveId(membership?.user_id ?? membership?.userId ?? user?.id)
	if (
		!effectiveUserId || !organizationId || !membershipId
		|| membershipUserId !== effectiveUserId || membership?.status !== 'ACTIVE'
	) return null
	return Object.freeze({ effectiveUserId, organizationId, membershipId })
}

export function matchesImpersonationTarget(tuple, target) {
	return Boolean(tuple && target
		&& Number(tuple.effectiveUser?.id) === target.effectiveUserId
		&& Number(tuple.organization?.id) === target.organizationId
		&& Number(tuple.membership?.id) === target.membershipId)
}
